var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.select.apply(null, arguments)},"mouseout":function($event){$event.stopPropagation();return _vm.blur.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.showLabel))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f42620a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/option.vue
// module id = 1l4C
// module chunks = 33